import { toast } from "react-toastify"

import { REQ } from "constants/api/requests"
import { IResponse } from "constants/interfaces"

import useApi, { parseError } from "util/api"

export type SnapshotTriggerResult = { ok: boolean; reason?: string }

class ReportsService {
  private openPdfInNewTab(blob: Blob) {
    const url = window.URL.createObjectURL(blob)
    window.open(url, "_blank")
    setTimeout(() => window.URL.revokeObjectURL(url), 10000)
  }

  // `source` (TEMPORARY, testing): "monolith" = the MNT computation; "microservice" = the
  // authoritative game-provider-nux path. Two mirror buttons on the GGR report page use this to
  // compare the two side by side. Remove with the buttons once parity is confirmed.
  public async getGGRMonthlyByProvider(
    producer: string,
    month: number,
    year: number,
    currency: string,
    source: "monolith" | "microservice" = "microservice"
  ): Promise<void> {
    try {
      const params = { producer, month, year, currency, source }
      const response = await useApi.get<Blob>(REQ.ADMIN_DASHBOARD.REPORTS.GGR_MONTHLY_REPORT_BY_PROVIDER, { params, responseType: "blob" })
      // const filename = `GGR_Monthly_By_Provider_${producer}_${year}_${month}_${currency}.pdf`
      this.openPdfInNewTab(response.data)
    } catch (err: any) {
      toast.error(err?.message ?? "Failed to get GGR monthly by provider")
    }
  }

  public async getGGRMonthlyByGame(producer: string, month: number, year: number, currency: string): Promise<void> {
    try {
      const params = { producer, month, year, currency }
      const response = await useApi.get<Blob>(REQ.ADMIN_DASHBOARD.REPORTS.GGR_MONTHLY_REPORT_BY_GAME, { params, responseType: "blob" })
      // const filename = `GGR_Monthly_By_Game_${producer}_${year}_${month}_${currency}.pdf`
      this.openPdfInNewTab(response.data)
    } catch (err: any) {
      toast.error(err?.message ?? "Failed to get GGR monthly by game")
    }
  }

  public async triggerGgrSnapshot(): Promise<SnapshotTriggerResult> {
    try {
      const { data } = await useApi.post<IResponse<SnapshotTriggerResult>>(REQ.ADMIN_DASHBOARD.REPORTS.GGR_SNAPSHOT)
      if (data.success) return { ok: !!data.response?.ok, reason: data.response?.reason }
      return { ok: false }
    } catch (err) {
      parseError(err, "Failed to trigger GGR snapshot")
      return { ok: false }
    }
  }

  public async triggerSportsbookGgrSnapshot(): Promise<SnapshotTriggerResult> {
    try {
      const { data } = await useApi.post<IResponse<SnapshotTriggerResult>>(REQ.ADMIN_DASHBOARD.REPORTS.SPORTSBOOK_GGR_SNAPSHOT)
      if (data.success) return { ok: !!data.response?.ok, reason: data.response?.reason }
      return { ok: false }
    } catch (err) {
      parseError(err, "Failed to trigger sportsbook GGR snapshot")
      return { ok: false }
    }
  }
}

export const reportsService = new ReportsService()
